/* eslint-disable */
import React from 'react'
import {
  StyleSheet,
  View,
  ActivityIndicator,
  Image,
  Text,
} from 'react-native'

const styles = StyleSheet.create({
})

export default class SuperImage extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {
      showActivityIndicator: false,
    }
  }
  
  static preload(source) {
    Image.preload && Image.preload(source)
  }
  
  onLoadStart() {
    this.afterLoadStart = setTimeout(() => {
      this.setState({
        showActivityIndicator: true,
      })
    }, 200)
  }
  
  onLoad() {
    clearTimeout(this.afterLoadStart)
    this.setState({
      showActivityIndicator: false,
    })
  }
  
  render() {
    return (
      <View style={this.props.style}>
        {this.state.showActivityIndicator &&
          <View style={{
            zIndex: 1,
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            justifyContent: 'center'
          }}>
          
            <ActivityIndicator size='small' color={this.props.style.backgroundColor == 'black' ? 'white' : 'black'} />
          </View>
        }
      
        <Image
          style={{width: '100%', height: '100%'}}
          source={{ uri: this.props.src }}
          onLoadStart={this.onLoadStart.bind(this)}
          onLoad={this.onLoad.bind(this)}
          resizeMode={this.props.resizeMode || 'cover'}>
        </Image>
      </View>
    )
  }
}
